import CommonUtil from "utils/CommonUtil";

/**
 * 사용자 Repository
 */
const userRepository = new (class UserRepository {
  /**
   * 로그인
   *
   * @param form
   */
  public async login(form: HTMLFormElement): Promise<any> {
    return CommonUtil.execute({
      url:"login",
      form: form
    })
  }

  /**
   * 로그아웃
   */
  public async logout(): Promise<boolean> {
    return await
      CommonUtil.execute({
          url:"logout"
      })
        .then((response) => {
          return true;
        })
        .catch((error) => {
          CommonUtil.showAxiosError(error);
          return false;
        })
  }
})();

export default userRepository;
